import { render, staticRenderFns } from "./FormSummarySidebar.vue?vue&type=template&id=7640a81f&scoped=true"
import script from "./FormSummarySidebar.vue?vue&type=script&lang=js"
export * from "./FormSummarySidebar.vue?vue&type=script&lang=js"
import style0 from "./FormSummarySidebar.vue?vue&type=style&index=0&id=7640a81f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7640a81f",
  null
  
)

export default component.exports